export enum FileFormat {
   CSV = 'CSV',
}
